import { filterAtomDefaults } from '@/consts/defaults/filterAtomDefaults';
import { atom } from 'jotai';

export const deselectedGamesAtom = atom(filterAtomDefaults.deselectedGameIds);
export const selectedGameRangeAtom = atom(filterAtomDefaults.gameRange);
export const selectedStartDateAtom = atom(filterAtomDefaults.startDate);
export const selectedEndDateAtom = atom(filterAtomDefaults.endDate);
export const selectedPeriodRangeAtom = atom(filterAtomDefaults.periodRange);
